<template>
  <div class="home-page">
    <site-header />
    <hero-banner @search="onHeroSearch" />
    <category-nav
      overlap
      @select="onCategorySelect"
      @show-all="goSearchPage"
    />
    <trademark-grid ref="trademarkGrid" />
    <process-steps />
    <info-panels />
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/home/SiteHeader.vue'
import HeroBanner from '@/components/home/HeroBanner.vue'
import CategoryNav from '@/components/home/CategoryNav.vue'
import TrademarkGrid from '@/components/home/TrademarkGrid.vue'
import ProcessSteps from '@/components/home/ProcessSteps.vue'
import InfoPanels from '@/components/home/InfoPanels.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'

export default {
  name: 'HomePage',
  components: {
    SiteHeader,
    HeroBanner,
    CategoryNav,
    TrademarkGrid,
    ProcessSteps,
    InfoPanels,
    SiteFooter
  },
  methods: {
    onHeroSearch(payload) {
      const grid = this.$refs.trademarkGrid
      if (!grid) return
      grid.applySearch(payload)
      this.$nextTick(() => {
        grid.scrollIntoView()
      })
    },
    onCategorySelect(cat) {
      const grid = this.$refs.trademarkGrid
      if (!grid) return
      grid.applySearch({
        keyword: '',
        category: String(cat.id)
      })
      this.$nextTick(() => {
        grid.scrollIntoView()
      })
    },
    goSearchPage() {
      this.$router.push({ path: '/search' })
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: var(--color-bg-main);
}
</style>
